import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import navReducer from '../features/nav/navSlice';
import authReducer from '../features/login/authSlice';
import uploaderReducer from '../features/uploader/uploader-slice';
import modalReducer from '../features/modal/modalSlice';
import { topshotsAPI } from './api';
import { setupListeners } from '@reduxjs/toolkit/query';

export const store = configureStore({
  reducer: {
    [topshotsAPI.reducerPath]: topshotsAPI.reducer,
    counter: counterReducer,
    nav: navReducer,
    auth: authReducer,
    uploader: uploaderReducer,
    modal: modalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(topshotsAPI.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

setupListeners(store.dispatch);
